import { useMutation } from "urql";

import { SendClikDataMeRequestDocument } from "../../../graphql/generated.ts";

export function useSendClikDataMERequest() {
  return useMutation(SendClikDataMeRequestDocument);
}
